import config from 'constants/config'

export function getBusinessTravellerSelectEnabled(businessAccount?: BusinessTraveller.CurrentBusinessAccount) : boolean {
  return (
    config.businessTraveller.currentAccountMode === 'business' &&
    businessAccount?.employee?.roles.includes('BUSINESS_ADMIN')) ?? false
}
